<template>
	<div>
		<el-form ref="filters" :model="requestFilters" @submit.native.prevent size="small">
			<el-row>
				<el-col :span="8">
					<el-form-item
						label="Periodo"
						prop="period">
						<el-date-picker
							style="width: 100%"
					      v-model="requestFilters.period"
					      type="daterange"
					      range-separator="a"
					      start-placeholder="Fecha inicio"
					      end-placeholder="Fecha fin">
					    </el-date-picker>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row style="margin-bottom: 1em">
                <el-col :span="24">
                	Agrupar por:
                </el-col>
            </el-row>
            <el-row style="margin-bottom: 1em">
                <el-col :span="24">
                    <el-checkbox-group v-model="requestFilters.checkList" :max="2">
                        <el-row>
                        	<el-checkbox label="cat_office_id" style="width: 22%">
                        		Representación
                            </el-checkbox>
                            <el-checkbox label="cat_acquisition_type_id" style="width: 22%">
                                Tipo de adquisición
                            </el-checkbox>
                            <el-checkbox label="sub_budget_id" style="width: 22%">
                                Subpartida
                            </el-checkbox>
                            <el-checkbox label="product_or_service_id" style="width: 22%">
                                Productos o Servicios
                            </el-checkbox>
                        </el-row>
                    </el-checkbox-group>
                </el-col>
            </el-row>
			<el-row style="margin-bottom: 1em">
                <el-col :span="24">
                    Filtrar por:
                </el-col>
            </el-row>
			<el-row :gutter="20">
				<el-col :span="6">
					<el-form-item
						label="Representación"
						prop="cat_office_id">
						<el-select
								style="width:100%"
								v-model="requestFilters.cat_office_id"
								filterable
								clearable
								placeholder="Seleccionar">
							<el-option
									v-for="(item,key) in catalogs.catOffice"
									:key="key"
									:label="item.type.name + ' ' + item.location"
									:value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item
						label="Tipo de adquisición"
						prop="cat_acquisition_type_id">
							<el-select
								style="width:100%"
								v-model="requestFilters.cat_acquisition_type_id"
								filterable
								clearable
								placeholder="Seleccionar">
							<el-option
									v-for="(item,key) in catalogs.catAcquisitionType"
									:key="key"
									:label="item.name"
									:value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item
						label="Subpartida"
						prop="sub_budget_id">
						<el-select
								style="width:100%"
								v-model="requestFilters.sub_budget_id"
								filterable
								clearable
								placeholder="Seleccionar">
							<el-option
									v-for="(item,key) in catalogs.catSubBudget"
									:key="key"
									:label="item.name"
									:value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item
						label="Productos o Servicios"
						prop="product_or_service_id">
						<el-select
								style="width:100%"
								v-model="requestFilters.product_or_service_id"
								filterable
								clearable
								placeholder="Seleccionar">
							<el-option
									v-for="(item,key) in filterProductService(catalogs.catProductsOrServicesArticles)"
									:key="key"
									:label="item.name"
									:value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
	</div>
</template>


<script>
	import {mapState, mapGetters, mapActions, mapMutations} from "vuex";
	export default {
		computed: {
			...mapGetters("statistic", {
				requestFilters: "requestFilters",
				catalogs: "catalogs",
			}),
		},
		methods:{
			filterProductService(data){
				if(!data) return [];
				return data = data.filter((item)=> item.type_product_or_service_id == 6);
			}
		}
	}
</script>